import { formatISO } from 'date-fns';
import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';
import {
    AdvancedSnapshotPagination,
    AdvancedSnapshotRequestParams,
    AdvancedSnapshotResponse
} from '@/pages/OperationsInsights/types/AdvancedSnapshot';

export async function fetchAdvancedSnapshotData(
    query: AdvancedSnapshotRequestParams
): Promise<AdvancedSnapshotResponse> {
    const result = { workstreams: [] } as AdvancedSnapshotResponse;
    if (query.fromRowNumber !== undefined && query.fromWorkstreamDefinitionId !== undefined) {
        result.pagination = { nextRowNumber: query.fromRowNumber, nextWorkstreamDefinitionId: query.fromWorkstreamDefinitionId };
    }

    do {
        const { workstreams, pagination } = await fetchAdvancedSnapshotDataPage(query, result.pagination);
        result.workstreams = result.workstreams.concat(workstreams);
        result.pagination = pagination;
    } while (result.pagination);
    return result;
}

function fetchAdvancedSnapshotDataPage(query: AdvancedSnapshotRequestParams, nextPage?: AdvancedSnapshotPagination) {
    const params = new URLSearchParams({
        type: query.type,
        workstreamDefinitionIds: query.workstreamDefinitionIds?.join(','),
        snapshotDate: formatISO(query.snapshotDate, { representation: 'date' })
    });
    if (query.pageSize) params.append('pageSize', `${query.pageSize}`);

    if (nextPage) {
        params.append('fromRowNumber', `${nextPage?.nextRowNumber}`);
        params.append('fromWorkstreamDefinitionId', `${nextPage.nextWorkstreamDefinitionId}`);
    }

    return fetchFromLambda<AdvancedSnapshotResponse>(`/workactivity/back-office/backlog/advanced-snapshots?${params}`);
}
